<template id="grup-details">
  <div class="maxw">
    <h2>Detalls Grup de Tallers</h2>
    <b-form>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Grup:">
            {{ grup.nombre }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Actiu:">
            {{ grup.isActive }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Web:">
            {{ grup.url }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <h3>Centres</h3>
      </b-row>
      <b-table striped hover :items="grup.centros" :fields="Centerfields"></b-table>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" @click="$router.push({name: 'GrupEdit', params: { grup: grup },})">Editar</b-button>
          <b-button class="mr-2" variant="outline-danger" @click="$router.push({name: 'GruptDelete', params: { grup: grup },})">Esborrar</b-button>
          <b-button class="mr-2" variant="outline-primary"><router-link :to="{ name: 'Grups'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
      <b-form-input :hidden="true" type="text" v-model="grup.identifier"></b-form-input>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    grup: {
      identifier: null,
      nombre: null,
      centros: [],
      isActive: null,
      url: null,
      isDelete: null
    }
  },
  data () {
    return {
      Centerfields: [
        {
          key: 'nombre',
          label: 'Nombre',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'dirección',
          label: 'Dirección',
          sortable: false
        },
        {
          key: 'poblacion',
          label: 'Población',
          sortable: false
        },
        {
          key: 'provincia',
          label: 'Provincia',
          sortable: false
        },
        {
          key: 'isActive',
          label: 'Está Activo',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        }
      ]
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
